module.exports = __webpack_public_path__ + "img/pause.1365979a.svg";